<template>
  <el-dialog
    title="修改vip套餐"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
        <div class="common-form">修改vip套餐</div>

        <el-form-item label="vip套餐名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入vip套餐名称"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <el-form-item label="价格" prop="price">
          <el-input
            v-model="form.price"
            placeholder="请输入价格"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <el-form-item label="划线价" prop="original_price">
          <el-input
            v-model="form.original_price"
            placeholder="请输入划线价"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <el-form-item label="优势" prop="advantages">
          <el-input
            type="textarea"
            v-model="form.advantages"
            placeholder="请输入优势描述"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <el-form-item label="服务" prop="services">
          <el-select
            v-model="form.services"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请输入服务内容"
            style="width: 460px"
          >
            <el-option
              v-for="item in serviceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="推荐" prop="recommend">
          <el-radio-group v-model="form.recommend">
            <el-radio :label="1">推荐</el-radio>
            <el-radio :label="0">不推荐</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="套餐时长" prop="duration">
          <el-radio-group v-model="form.duration">
            <el-radio :label="0">日</el-radio>
            <el-radio :label="1">月</el-radio>
            <el-radio :label="2">季</el-radio>
            <el-radio :label="3">年</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input>
        </el-form-item>

        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import PackageApi from "@/api/package.js";

export default {
  data() {
    return {
      form: {
        name: "",
        price: "",
        original_price: "",
        advantages: "",
        services: [],
        recommend: "", // 默认不推荐
        duration: "",
        sort: 50,
        vip_package_id: ""
      },
      serviceOptions: [
        { value: "专属客服", label: "专属客服" },
        { value: "优先处理", label: "优先处理" },
        { value: "24小时在线支持", label: "24小时在线支持" },
        { value: "专属折扣", label: "专属折扣" },
        { value: "免费升级", label: "免费升级" },
        { value: "高级数据分析", label: "高级数据分析" },
        { value: "专属活动邀请", label: "专属活动邀请" },
        { value: "定制化服务", label: "定制化服务" },
        { value: "无限存储空间", label: "无限存储空间" },
        { value: "多设备同时登录", label: "多设备同时登录" },
        { value: "专属内容访问", label: "专属内容访问" },
        { value: "高级安全保护", label: "高级安全保护" },
        { value: "专属优惠券", label: "专属优惠券" },
        { value: "快速退款通道", label: "快速退款通道" },
        { value: "会员专属标识", label: "会员专属标识" },
        { value: "生日特权", label: "生日特权" },
        { value: "专属商品", label: "专属商品" },
        { value: "提前体验新功能", label: "提前体验新功能" },
        { value: "专属社群", label: "专属社群" },
        { value: "个性化推荐", label: "个性化推荐" },
        { value: "积分加倍", label: "积分加倍" },
        { value: "免广告特权", label: "免广告特权" },
        { value: "专属教程", label: "专属教程" },
        { value: "一对一专家咨询", label: "一对一专家咨询" },
        { value: "优先抢购权", label: "优先抢购权" },
        { value: "专属会员日", label: "专属会员日" },
        { value: "免费试用新产品", label: "免费试用新产品" },
        { value: "专属支付通道", label: "专属支付通道" },
        { value: "高级隐私保护", label: "高级隐私保护" },
        { value: "专属会员卡", label: "专属会员卡" }
      ],
      loading: false,
      rules: {
        name: [
          { required: true, message: "请输入vip套餐名称", trigger: "blur" }
        ],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }]
      },
      dialogVisible: false
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add", "vip_package_id"],
  methods: {
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    getDetail() {
      let self = this;
      PackageApi.detail({ vip_package_id: self.vip_package_id }, true)
        .then(res => {
          self.form = res.data;
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.vip_package_id = self.vip_package_id;

      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          PackageApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/vip_service/package/part/edit.vue